import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";

export const useActionFieldModalWrapper = () => {
  const isActionFieldsModalOpen = useAdminPanelStore(
    (state) => state.isActionFieldsModalOpen
  );
  const setIsActionFieldsModalOpen = useAdminPanelStore(
    (state) => state.setIsActionFieldsModalOpen
  );

  const setSelectedRecord = useAdminPanelStore(
    (state) => state.setSelectedRecord
  );
  const selectedRecord = useAdminPanelStore((state) => state.selectedRecord);

  const openActionFieldModal = ({ record }) => {
    setSelectedRecord(record);
    setIsActionFieldsModalOpen(true);
  };
  const closeActionFieldModal = () => {
    setIsActionFieldsModalOpen(false);
  };
  return {
    isActionFieldsModalOpen,
    openActionFieldModal,
    closeActionFieldModal,
    selectedRecord,
  };
};
